module.exports = __webpack_public_path__ + "static/exercise-img-2-a99583fe6b72d209e3943f0158843949.png";